import { closeModal, openModal } from 'components/modal/modules/dispatcher/methods';
// import { RouteTo } from 'lib/utils/routing';
import * as React from "react";
import { withCookies } from "react-cookie";
import { connect } from "react-redux";
// import { fetchGraphQL } from 'services/graphql/GraphQL';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import UserDucks from "stores/ducks/User.duck";

/**
 * Checks for the presence of a user cookie and sets it to the redux state along with some more data
 * retrieved from the server.
 */
class AppAuth extends React.PureComponent<{ cookies?: any; dispatch: any; user: any }> {

  constructor(props) {
    super(props)
    this.setUpStripe = this.setUpStripe.bind(this)
  }

  public setUpStripe() {
    fetchGraphQL(`
		  mutation {
			user {
				setUpStripeStandard(email:"${this.props.user!.email}")
			}
		  }
		`).then(response => {
      if (response.user.setUpStripeStandard) {
        if (response.user.setUpStripeStandard === 'error') {
          alert('Something went wrong. Please reach out to support.')
        } else {
          window.location.href = response.user.setUpStripeStandard
        }
      }
    })
  }

  public componentDidMount() {
    // If user is logged in then 
    const user = this.props.cookies.get("user");
    if (user) {
      this.props.dispatch(UserDucks.setUser(user));
      if (!user.isAdmin && (user.stripeId === undefined || user.stripeId === null) && window.location.pathname.includes('/campaigns')) {
        const content = <div style={{ padding: '20px' }}>
          Set up payments to receive payouts and create paid inventory on your own campaigns.
          If you are an affiliate, your payout will be sent to the campaign owner if you don't have payments set up.
          <div style={{ width: '100%', textAlign: 'center', paddingTop: '20px' }}>
            <button
              onClick={() => {
                this.setUpStripe()
              }}
              className="new-button-save"
              style={{ cursor: 'pointer' }}
            >
              SET UP PAYOUTS
                  </button>
          </div>
          <div style={{ width: '100%', textAlign: 'center', paddingTop: '10px' }}>
            <button className='new-button-cancel' onClick={() => closeModal()}>
              CANCEL
              </button>
          </div>
        </div>
        this.props.dispatch(UserDucks.setPaymentsReminder(false));
        openModal(content, 'PAYMENT SETUP REMINDER', [])
      }
    }
    this.props.dispatch(UserDucks.setLoading(false))
  }

  public render() {
    return null;
  }

}

const mapStateToProps = state => {
  return {
    isLoggedin: UserDucks.isAuthenticated(state),
    user: UserDucks.getUser(state),
    paymentsReminder: UserDucks.getPaymentsReminder(state)

  };
};

export default withCookies(connect(mapStateToProps)(AppAuth));



// WEBPACK FOOTER //
// ./src/components/app/AppAuth.tsx